import { CalculatorOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Modal, message } from 'antd';
import { uniqueId } from 'lodash';
import { makeAutoObservable, runInAction } from 'mobx';
import { get, post } from '../../axios/axios';
import { generateReferenceId } from '../../utils/generateReferenceId';
import { DOC_TYPES, DocType } from './const';
import styles from './index.module.scss';
import { CodeIcon, PicIcon, TableIcon, DataIcon } from './Summary/icons';
import { DOCTYPE_PAPER_TYPE_MAP } from './const';

const HIDDEN_SERVICE_STYPES = ['gzd_aigc', 'wf_aigc'];

class SummaryStore {
    // 全文题目
    majorName = '';
    // 全文类型
    docType = DOC_TYPES[0].key;
    // 当前分步表单步数
    currentStep = 0;
    // 是否使用Ultra
    useUltra = false;
    // step1的学科分类
    categories = [];
    // step1选中的图、表、代码、公式
    autoLightTypes = [];
    // step1的excel文献上传的id
    refFileId = null;

    // step1的免责声明是否勾选
    isCheckConfirm = true;
    // 是否使用三级大纲
    isUseThreeOutline = false;
    // 是否正在生成大纲
    isLoadingSummary = false;
    // step2的大纲数据
    paragraphs = [];
    // step3右侧的附加服务列表
    serviceList = [];
    // step3的全文信息
    paperInfo = null;
    // 是否显示Ultra弹窗
    showUltraDialog = false;
    // 是否正在生成step3的预览
    isLoadingPreview = false;
    // step3勾选附加附加服务重新请求的loading
    isExtraloading = false;
    // ste3p的继续预览loading
    nextPreviewLoading = false;
    // 是否已经预览结束
    hasPreviewEnd = false;
    // 是否已经确认图、表、代码、公式
    hasConfirmTable = false;
    // 再次展示选择的图、表、代码、公式弹窗visible
    showCheckTableDialog = false;
    // step3.4的目录数据是否加载完毕
    catalogueDataLoaded = false;
    // step3.4的目录初始数据
    catalogueInceptionData = [];
    // step3.4的目录数据
    catalogueData = [];

    // Step4正在加载数据
    isLoadingStep4Data = false;
    // step4的摘要数据是否加载完毕
    abstractDataLoaded = false;
    // step4的摘要初始数据
    abstractDataInceptionData = {
        abstractCn: '',
        abstractEn: '',
    };
    // step4的摘要数据
    abstractData = {
        abstractCn: '',
        abstractEn: '',
    };
    // step4的内容数据是否加载完毕
    contentDataLoaded = false;
    // step4初始内容数据
    contentInceptionData = [];
    // step4内容数据
    contentData = [];
    _tempAutoText = '';

    // 文献
    customReference = {
        checked: false,
        // customReferenceDocument: '',
        customReferenceDocument: [],
    };
    confirmCustomReferenceDocumentModal = false;
    isConfirmCustomReferenceDocument = false;
    isReref = true;
    // 字数选择
    wordCount = 15000;

    // 模型类型选择
    modelType = 'NORMAL';

    additionalNotes = ''; // 补充说明内容

    // 是否推荐英文文献
    recommendEnglishLiterature = false;

    // -----灵感新增字段
    qy = {
        //  是否需要开启参考文献
        ls: false,
        ll: 0,
        // 类型列表
        paperTypes: [],
        // 类型 1为毕业长文
        type: 1,
        // step2的下一步loading
        nextLoading: false,
        // step1的关键词
        keywords: [],
        // step2的标题数组
        titles: [],
        // step2的选中的标题索引
        selectIdx: 0,
        // step2的聚焦的标题索引
        focusIdx: -1,
        // step3的文献列表
        wenxianList: [],
        // step3的搜索关键词
        searchKeywords: '',
        // step3的菜单列表
        menus: [],
        // step3的选中的文献ID列表
        selectIdList: [],
        // step4的摘要数组
        abstractList: [],
        // step4的选中的摘要索引
        selectAbstractIdx: 0,
        // step4的聚焦的摘要索引
        focusAbstractIdx: -1,
        // step5的大纲数据
        outlines: [],
    };

    constructor() {
        makeAutoObservable(this);
        this.initApiVersion();
        this.getServiceList();
        // this.getTypeList();
        this.getCatogories();
    }

    reset() {
        this.majorName = '';
        this.refFileId = null;
        this.isLoadingSummary = false;
        this.paragraphs = null;
        this.serviceList = [];
        this.isCheckConfirm = true;
        this.isUseThreeOutline = false;
        this.currentStep = 0;
        this.paperInfo = null;
        this.isLoadingPreview = false;
        this.isExtraloading = false;
        this.nextPreviewLoading = false;
        this.showUltraDialog = false;
        this.hasPreviewEnd = false;
        this.autoLightTypes = [];
        this._tempAutoText = '';
        this.showCheckTableDialog = false;
        this.hasConfirmTable = false;
        this.catalogueData = [];
        // this.customReference = { checked: false, customReferenceDocument: '' };
        this.customReference = { checked: true, customReferenceDocument: [] };
        this.isConfirmCustomReferenceDocument = false;
        this.confirmCustomReferenceDocumentModal = false;
        this.isReref = true;
        this.recommendEnglishLiterature = false;
        this.docType = DOC_TYPES[0].key;
        this.qy = {
            ls: false,
            ll: 0,
            paperTypes: [],
            type: '',
            nextLoading: false,
            keywords: [],
            searchKeywords: '',
            titles: [],
            selectIdx: 0,
            focusIdx: -1,
            wenxianList: [],
            menus: [],
            selectIdList: [],
            abstractList: [],
            selectAbstractIdx: 0,
            focusAbstractIdx: -1,
            outlines: [],
        };
    }

    // -----灵感新增方法 start
    async getTypeList() {
        const { data } = await get('/ai/paper/type/list');
        this.paperTypes = data.map((item) => ({
            value: item.id,
            label: item.remark,
            ...item,
        }));
    }
    // step1设置关键词
    setKeywords = (v) => {
        this.qy.keywords = v;
    };
    async step1Submit() {
        if (!this.majorName) {
            message.warning('请输入全文题目后一键');
            return;
        }
        this.qy.nextLoading = true;
        this.qy.selectIdx = -1;
        this.qy.focusIdx = -1;
        try {
            // const res = await post("/ai/paper/gen/title", {
            const res = await post('/ai/ai/paper/gen/title', {
                majorName: this.majorName,
                keywords: this.qy.keywords.join(','),
                type: this.qy.type,
            });
            this.qy.titles = [this.majorName, ...res.data];
            this.qy.selectIdx = 0;
            this.qy.focusIdx = 0;
            this.qy.nextLoading = false;
            this.currentStep = 1;
        } catch (error) {
            this.qy.nextLoading = false;
        }
    }
    // step2设置选中的标题索引
    setSelectIdx = (v) => {
        this.qy.selectIdx = v;
    };
    // step2设置聚焦的标题索引
    setFocusIdx = (v) => {
        this.qy.focusIdx = v;
    };
    // step2修改标题
    step2Change = (i, v) => {
        this.qy.selectIdx = i;
        this.qy.titles[i] = v;
        if (!v) {
            this.qy.selectIdx = -1;
        }
    };
    // step2选择标题
    step2Select = (i) => {
        this.qy.selectIdx = i;
        // 同步更新 majorName 为选中的标题
        this.majorName = this.qy.titles[i];
    };
    async step2Submit() {
        this.qy.nextLoading = true;
        try {
            const res = await this.fetchWenxianList();
            if (res.success) {
                this.qy.searchKeywords = this.qy.titles[this.qy.selectIdx];
                this.currentStep = 2;
            }
            return Promise.resolve(res);
        } catch (error) {
            return Promise.reject(error);
        } finally {
            this.qy.nextLoading = false;
        }
    }
    // 获取文献列表。传入 subject 时按搜索主题查；否则用全文题目
    async fetchWenxianList(params) {
        // 请求序号：并发搜索时只有最新请求负责收尾，避免 loading 被提前关闭
        this._wenxianReqSeq = (this._wenxianReqSeq || 0) + 1;
        const reqSeq = this._wenxianReqSeq;
        this.qy.nextLoading = true;
        try {
            const searchSubject = (params?.subject || '').trim();
            const requestParams = {
                majorName: searchSubject || this.majorName,
            };
            const res = await post('/ai/ai/references/search', requestParams);
            // 并发搜索时丢弃过期响应，避免旧结果覆盖新结果
            if (reqSeq !== this._wenxianReqSeq) {
                return Promise.resolve(res);
            }
            // 检查返回状态并更新文献列表
            if (res.success && res.data) {
                const newData = res.data.map((it, index) => {
                    return {
                        ...it,
                        id: generateReferenceId(it.references, index),
                    };
                });
                // 以文献内容为键过滤掉列表中已存在的条目，避免反复搜索时出现重复
                const existingRefs = new Set(
                    this.qy.wenxianList.map((it) => it.references).filter(Boolean),
                );
                const deduped = newData.filter(
                    (it) => !it.references || !existingRefs.has(it.references),
                );
                // 检查是否是第一次请求
                if (!this.qy.wenxianList.length) {
                    this.qy.wenxianList = [...newData];
                } else {
                    this.qy.wenxianList = [...deduped, ...this.qy.wenxianList];
                }
            }
            return Promise.resolve(res);
        } catch (error) {
            return Promise.reject(error);
        } finally {
            if (reqSeq === this._wenxianReqSeq) {
                this.qy.nextLoading = false;
            }
        }
    }
    stepWenxianChange(i, v) {
        const item = this.qy.wenxianList[i];
        if (item && item.id) {
            const isSelected = this.qy.selectIdList.includes(item.id);
            if (!isSelected) {
                this.qy.selectIdList.push(item.id);
            }
        }
        // 更新文献内容
        this.qy.wenxianList[i] = v;
    }
    stepWenxianSelectAll(checked) {
        const systemWenxianIds = this.qy.wenxianList
            .filter((item) => item && item.id)
            .map((item) => item.id);
        if (checked) {
            // 全选
            this.qy.selectIdList = [...systemWenxianIds];
            return;
        }
        this.qy.selectIdList = [];
    }
    stepWenxianSelect(i) {
        // 处理系统文献
        const item = this.qy.wenxianList[i];
        if (item && item.id) {
            const isSelected = this.qy.selectIdList.includes(item.id);
            if (isSelected) {
                // 取消选中
                const idx = this.qy.selectIdList.indexOf(item.id);
                this.qy.selectIdList.splice(idx, 1);
            } else {
                // 选中
                this.qy.selectIdList.push(item.id);
            }
        }
    }
    step4Foucs(i) {
        this.qy.focusAbstractIdx = i;
    }
    step4Select(i) {
        this.qy.selectAbstractIdx = i;
    }
    step4Change(i, v) {
        this.qy.selectAbstractIdx = i;
        this.qy.abstractList[i] = v;
        if (!v) {
            this.qy.selectAbstractIdx = -1;
        }
    }
    getll() {
        if (this.qy.ll > 20) {
            this.qy.ll = 0;
        } else {
            this.qy.ll = this.qy.ll + 1;
        }
        return this.qy.ll;
    }
    async moreStep4() {
        try {
            this.qy.nextLoading = true;
            const res = await post('/ai/paper/gen/abstracts', {
                majorName: this.majorName,
                keywords: this.qy.keywords.join(','),
                paperTitle: this.qy.titles[this.qy.selectIdx],
                ll: this.getll(),
                ls: this.qy.ls ? 'y' : 'n',
                type: this.qy.type,
            });
            this.qy.abstractList.push(res.data);
            this.qy.nextLoading = false;
        } catch (err) {
            this.qy.nextLoading = false;
        }
    }
    async step3Submit(notiApi) {
        try {
            // 没有引用文献和推荐文献
            // if (
            //   this.customReference.customReferenceDocument.length === 0 &&
            //   this.qy.selectIdList.length === 0
            // ) {
            //   message.info("请至少选择一篇推荐文献或自定义文献");
            //   return;
            // }
            this.qy.nextLoading = true;
            const key = `getSummary`;
            this._tempAutoText = this.getAutoText();
            // 滑动到整个页面顶部
            document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
            notiApi.info({
                key,
                message: '大纲开始生成',
                description: GetSummaryNotiDom(this.getAutoText()),
                className: styles.getSummaryNoti,
                duration: 0,
                icon: <InfoCircleOutlined />,
            });
            try {
                this.paragraphs = null;
                this.isLoadingSummary = true;

                const result = await post('/ai/ai/paper/gen/outline2', {
                    subject: '11',
                    majorName: this.majorName,
                    // threeOutline: 'y', // y or n
                    enableLevel3TableOfContents: !!this.isUseThreeOutline,
                    wordCount: this.wordCount,
                    additionalNotes: this.additionalNotes,
                    version: this.useUltra ? 'premium' : 'd',
                    autoLightTypes:
                        this.autoLightTypes && this.autoLightTypes.join
                            ? this.autoLightTypes.join(',')
                            : '',
                    isReref: this.isReref ? 'y' : 'n',
                    funType: this.getFunType,
                });
                this.paragraphs = result.data;
                this.currentStep = 3;
            } catch (e) {
                console.error(e);
            } finally {
                setTimeout(() => {
                    this.isLoadingSummary = false;
                    setTimeout(() => {
                        document
                            .getElementById('summaryHeader')
                            ?.scrollIntoView({ behavior: 'smooth' });
                    }, 500);
                }, 700);
                notiApi.destroy(key);
            }
        } catch (err) {
            this.qy.nextLoading = false;
        }
    }
    async step4Submit() {
        try {
            this.qy.nextLoading = true;
            // const res = await post("/ai/paper/gen/outline", {
            const res = await post('/ai/paper/gen/new/outline', {
                majorName: this.majorName,
                keywords: this.qy.keywords.join(','),
                paperTitle: this.qy.titles[this.qy.selectIdx],
                paperAbstracts: this.qy.abstractList[this.qy.selectAbstractIdx],
                type: this.qy.type,
                autoLightTypes: this.autoLightTypes ? this.autoLightTypes.join(',') : '',
            });
            this.qy.outlines = res.data.map((d) => ({
                id: uniqueId('step3'),
                ...d,
            }));
            this.qy.outlines = [...res.data];
            this.qy.nextLoading = false;
            this.currentStep = 4;
        } catch (error) {
            this.qy.nextLoading = false;
        }
    }
    // 大纲页面
    addTitle(opts) {
        if (this.qy.nextLoading) {
            message.info('长文预览生成中，请结束后再试');
            return;
        }

        const {
            level,
            level1idx,
            level2idx,
            level3idx,
            inputMain,
            inputSub,
            isAfter,
            insertType, // 'same' | 'sub'
            selectedSubChapter, // 选中的子章节索引
        } = opts;

        // 插入同级章节
        if (insertType === 'same') {
            const idxDiff = isAfter ? 1 : 0;

            if (level === 1) {
                this.qy.outlines.splice(level1idx + idxDiff, 0, {
                    chapter: inputMain,
                    sections: [],
                });
            } else if (level === 2) {
                this.qy.outlines[level1idx].sections.splice(level2idx + idxDiff, 0, {
                    chapter: inputMain,
                    chapterAbstract: inputSub,
                    extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                    selected_extra: '',
                    selectedChartType: '',
                    subsections: [],
                });
            } else if (level === 3) {
                this.qy.outlines[level1idx].sections[level2idx].subsections.splice(
                    level3idx + idxDiff,
                    0,
                    {
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                    },
                );
            }
            return;
        }

        // 插入子级章节
        if (insertType === 'sub') {
            // 一级章节插入节
            if (level === 1) {
                // 确保sections是一个数组
                if (!this.qy.outlines[level1idx].sections) {
                    this.qy.outlines[level1idx].sections = [];
                }
                const sections = this.qy.outlines[level1idx].sections;
                // 如果没有子节，直接添加到末尾
                if (!sections.length) {
                    sections.push({
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                        subsections: [],
                    });
                } else {
                    // 有子节时，根据选择的位置插入
                    const insertIdx = selectedSubChapter + (isAfter ? 1 : 0);
                    sections.splice(insertIdx, 0, {
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                        subsections: [],
                    });
                }
            }
            // 二级节插入小节
            else if (level === 2) {
                // 确保subsections是一个数组
                if (!this.qy.outlines[level1idx].sections[level2idx].subsections) {
                    this.qy.outlines[level1idx].sections[level2idx].subsections = [];
                }
                const subsections = this.qy.outlines[level1idx].sections[level2idx].subsections;
                // 如果没有小节，直接添加到末尾
                if (!subsections.length) {
                    subsections.push({
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                    });
                } else {
                    // 有小节时，根据选择的位置插入
                    const insertIdx = selectedSubChapter + (isAfter ? 1 : 0);
                    subsections.splice(insertIdx, 0, {
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                    });
                }
            }
        }
    }

    editTitle(opts) {
        // if (this.nextLoading) {
        //   message.info("论文预览生成中，请结束后再试");
        //   return;
        // }

        const { level, level1idx, level2idx, level3idx, inputMain, inputSub } = opts;
        if (level === 1) {
            this.qy.outlines[level1idx] = {
                ...this.qy.outlines[level1idx],
                chapter: inputMain,
            };
        } else if (level === 2) {
            this.qy.outlines[level1idx].sections[level2idx] = {
                ...this.qy.outlines[level1idx].sections[level2idx],
                chapter: inputMain,
                chapterAbstract: inputSub,
            };
        } else if (level === 3) {
            this.qy.outlines[level1idx].sections[level2idx].subsections[level3idx] = {
                ...this.qy.outlines[level1idx].sections[level2idx].subsections[level3idx],
                chapter: inputMain,
                chapterAbstract: inputSub,
            };
        }
    }

    deleteTitle(opts) {
        // if (this.nextLoading) {
        //   message.info("论文预览生成中，请结束后再试");
        //   return;
        // }

        const { level, level1idx, level2idx, level3idx, txt } = opts;
        Modal.confirm({
            title: '确认删除吗',
            content: `确认删除章节<${txt}>吗？章节不足可能会导致长文总体字数不足`,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                if (level === 1) {
                    this.qy.outlines.splice(level1idx, 1);
                } else if (level === 2) {
                    this.qy.outlines[level1idx].sections.splice(level2idx, 1);
                } else if (level === 3) {
                    this.qy.outlines[level1idx].sections[level2idx].subsections.splice(
                        level3idx,
                        1,
                    );
                }
            },
            onCancel: () => {},
        });
    }
    // -----灵感新增方法 end

    setDocType(v) {
        this.docType = v;
    }
    setisReref(v) {
        this.isReref = v;
    }
    setIsUseThreeOutline(v) {
        this.isUseThreeOutline = v;
    }
    addCustomReferenceDocument = (v) => {
        this.customReference.customReferenceDocument = [
            ...this.customReference.customReferenceDocument,
            ...v,
        ];
    };
    deletesCustomReferenceDocument = (id) => {
        console.log('id', id);
        this.customReference.customReferenceDocument =
            this.customReference.customReferenceDocument.filter((item) => item.id !== id);
    };
    onAutoLightChange = (list) => {
        this.autoLightTypes = list;
    };
    setCurrentStep(step) {
        this.currentStep = step;
    }
    setIsCheckConfirm(check) {
        this.isCheckConfirm = check;
    }
    getAutoText() {
        const TYPES_DESC = {
            CODE: '代码',
            TABLE: '表',
            DIAGRAM: '图',
            FORMULA: '公式',
        };
        return (
            (this.autoLightTypes && this.autoLightTypes?.map((i) => TYPES_DESC[i])?.join(',')) || ''
        );
    }
    // 获取编辑器大纲和目录
    async getCatalogueData() {
        try {
            const res = await get('/ai/ai/paper/editor/get/outline', {
                orderNo: this.paperInfo.orderNo,
            });

            this.catalogueData = convertToTreeStructure(res.data);
            this.catalogueInceptionData = res.data;
            this.catalogueDataLoaded = true;
        } catch (e) {
            this.catalogueDataLoaded = false;
        }
    }
    // 获取编辑器摘要
    async getAbstractData() {
        try {
            const res = await get('/ai/ai/paper/editor/get/abstract', {
                orderNo: this.paperInfo.orderNo,
            });

            this.abstractDataInceptionData = res.data;
            this.abstractDataLoaded = true;
        } catch (e) {
            this.abstractDataLoaded = false;
        }
    }
    // 获取编辑器内容
    async getContentData() {
        try {
            const res = await get('/ai/ai/paper/editor/get/content', {
                orderNo: this.paperInfo.orderNo,
            });

            this.contentInceptionData = res.data;
            this.contentDataLoaded = true;
        } catch (e) {
            this.contentDataLoaded = false;
        }
    }

    async goStep4() {
        this.isLoadingStep4Data = true;
        await Promise.all([this.getAbstractData(), this.getContentData()]).finally(() => {
            this.isLoadingStep4Data = false;
        });
        this.currentStep = 3;
    }
    initApiVersion() {
        this.useUltra = false;
    }
    toggleUseUltra() {
        if (this.isLoadingSummary) {
            message.warning('大纲生成中，请结束后再试');
            return;
        }
        // 保存当前的 docType
        const savedDocType = this.docType;
        // 保存题目
        const savedMajorName = this.majorName;
        // 保存选择的服务类型
        const savedAutoLightTypes = [...this.autoLightTypes];
        // 保存关键词
        const savedKeywords = [...this.qy.keywords];
        // 保存字数
        const savedWordCount = this.wordCount;

        this.reset();
        // 恢复 docType
        this.docType = savedDocType;
        this.majorName = savedMajorName;
        this.autoLightTypes = savedAutoLightTypes;
        this.qy.keywords = savedKeywords;
        this.wordCount = savedWordCount;
        this.useUltra = !this.useUltra;
    }
    toggleUltraDialog() {
        this.showUltraDialog = !this.showUltraDialog;
    }
    hideUltraDialog() {
        this.showUltraDialog = false;
    }
    changeMajorName = (v) => {
        runInAction(() => {
            this.majorName = v;
        });
    };

    addTitle(opts) {
        if (this.isLoadingPreview) {
            message.info('全文预览生成中，请结束后再试');
            return;
        }

        const {
            level,
            level1idx,
            level2idx,
            level3idx,
            inputMain,
            inputSub,
            isAfter,
            insertType, // 'same' | 'sub'
            selectedSubChapter, // 选中的子章节索引
        } = opts;

        // 插入同级章节
        if (insertType === 'same') {
            const idxDiff = isAfter ? 1 : 0;

            if (level === 1) {
                // 判断是否为文献综述或开题报告，如果是则初始化付费项字段
                const isSupportLevel1Extra =
                    this.docType === DocType.LITERATURE_REVIEW ||
                    this.docType === DocType.PROPOSAL_REPORT;
                const newParagraph = {
                    chapter: inputMain,
                    sections: [],
                };
                // 如果是文献综述或开题报告，初始化付费项字段（只包含表格和图）
                if (isSupportLevel1Extra) {
                    newParagraph.extraType = 'NORMAL,TABLE,DIAGRAM';
                    newParagraph.selected_extra = '';
                    newParagraph.selectedChartType = '';
                }
                this.paragraphs.splice(level1idx + idxDiff, 0, newParagraph);
            } else if (level === 2) {
                this.paragraphs[level1idx].sections.splice(level2idx + idxDiff, 0, {
                    chapter: inputMain,
                    chapterAbstract: inputSub,
                    extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                    selected_extra: '',
                    selectedChartType: '',
                    subsections: [],
                });
            } else if (level === 3) {
                this.paragraphs[level1idx].sections[level2idx].subsections.splice(
                    level3idx + idxDiff,
                    0,
                    {
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                    },
                );
            }
            return;
        }

        // 插入子级章节
        if (insertType === 'sub') {
            // 一级章节插入节
            if (level === 1) {
                // 确保sections是一个数组
                if (!this.paragraphs[level1idx].sections) {
                    this.paragraphs[level1idx].sections = [];
                }
                const sections = this.paragraphs[level1idx].sections;
                // 如果没有子节，直接添加到末尾
                if (!sections.length) {
                    sections.push({
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                        subsections: [],
                    });
                } else {
                    // 有子节时，根据选择的位置插入
                    const insertIdx = selectedSubChapter + (isAfter ? 1 : 0);
                    sections.splice(insertIdx, 0, {
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                        subsections: [],
                    });
                }
            }
            // 二级节插入小节
            else if (level === 2) {
                // 确保subsections是一个数组
                if (!this.paragraphs[level1idx].sections[level2idx].subsections) {
                    this.paragraphs[level1idx].sections[level2idx].subsections = [];
                }
                const subsections = this.paragraphs[level1idx].sections[level2idx].subsections;
                // 如果没有小节，直接添加到末尾
                if (!subsections.length) {
                    subsections.push({
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                    });
                } else {
                    // 有小节时，根据选择的位置插入
                    const insertIdx = selectedSubChapter + (isAfter ? 1 : 0);
                    subsections.splice(insertIdx, 0, {
                        chapter: inputMain,
                        chapterAbstract: inputSub,
                        extraType: 'NORMAL,CODE,TABLE,DIAGRAM,FORMULA,DATA',
                        selected_extra: '',
                        selectedChartType: '',
                    });
                }
            }
        }
    }

    editTitle(opts) {
        if (this.isLoadingPreview) {
            message.info('全文预览生成中，请结束后再试');
            return;
        }

        const { level, level1idx, level2idx, level3idx, inputMain, inputSub } = opts;
        if (level === 1) {
            this.paragraphs[level1idx] = {
                ...this.paragraphs[level1idx],
                chapter: inputMain,
            };
        } else if (level === 2) {
            this.paragraphs[level1idx].sections[level2idx] = {
                ...this.paragraphs[level1idx].sections[level2idx],
                chapter: inputMain,
                chapterAbstract: inputSub,
            };
        } else if (level === 3) {
            this.paragraphs[level1idx].sections[level2idx].subsections[level3idx] = {
                ...this.paragraphs[level1idx].sections[level2idx].subsections[level3idx],
                chapter: inputMain,
                chapterAbstract: inputSub,
            };
        }
    }

    deleteTitle(opts) {
        if (this.isLoadingPreview) {
            message.info('全文预览生成中，请结束后再试');
            return;
        }

        const { level, level1idx, level2idx, level3idx, txt } = opts;
        Modal.confirm({
            title: '确认删除吗',
            content: `确认删除章节<${txt}>吗？章节不足可能会导致全文总体字数不足`,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                if (level === 1) {
                    this.paragraphs.splice(level1idx, 1);
                } else if (level === 2) {
                    this.paragraphs[level1idx].sections.splice(level2idx, 1);
                } else if (level === 3) {
                    this.paragraphs[level1idx].sections[level2idx].subsections.splice(level3idx, 1);
                }
            },
            onCancel: () => {},
        });
    }

    changeTitleExtra(opts) {
        if (this.isLoadingPreview) {
            message.info('全文预览生成中，请结束后再试');
            return;
        }

        const { v, level, level1idx, level2idx, level3idx } = opts;
        const { checked, type, chartTypes, chartTypeCn } = v;

        // 判断是否为文献综述或开题报告，如果是则一级标题支持付费项
        const isSupportLevel1Extra =
            this.docType === DocType.LITERATURE_REVIEW || this.docType === DocType.PROPOSAL_REPORT;

        // 处理图表类型选择（多选）
        if (type === 'CHART') {
            const hasChartTypes = Array.isArray(chartTypes) && chartTypes.length > 0;

            if (level === 1) {
                // 一级章节支持（仅限文献综述和开题报告）
                if (isSupportLevel1Extra) {
                    const paragraph = this.paragraphs[level1idx];
                    // 确保有 extraType 字段（只包含表格和图）
                    if (!paragraph.extraType) {
                        paragraph.extraType = 'NORMAL,TABLE,DIAGRAM';
                    }
                    const origin = paragraph.selected_extra || '';

                    // 同步更新 selected_extra 的 DIAGRAM 状态
                    const updatedSelectedExtra = hasChartTypes
                        ? modifySelectExtra({ origin, checked: true, type: 'DIAGRAM' })
                        : modifySelectExtra({ origin, checked: false, type: 'DIAGRAM' });

                    this.paragraphs[level1idx] = {
                        ...paragraph,
                        selectedChartType: hasChartTypes ? chartTypes.join(',') : '',
                        chartTypeCn: chartTypeCn || null,
                        selected_extra: updatedSelectedExtra,
                    };
                }
            } else if (level === 2) {
                const section = this.paragraphs[level1idx].sections[level2idx];
                const origin = section.selected_extra || '';

                // 同步更新 selected_extra 的 DIAGRAM 状态
                const updatedSelectedExtra = hasChartTypes
                    ? modifySelectExtra({ origin, checked: true, type: 'DIAGRAM' })
                    : modifySelectExtra({ origin, checked: false, type: 'DIAGRAM' });

                this.paragraphs[level1idx].sections[level2idx] = {
                    ...section,
                    selectedChartType: hasChartTypes ? chartTypes.join(',') : '',
                    chartTypeCn: chartTypeCn || null,
                    selected_extra: updatedSelectedExtra,
                };
            } else if (level === 3) {
                const subsection =
                    this.paragraphs[level1idx].sections[level2idx].subsections[level3idx];
                const origin = subsection.selected_extra || '';

                // 同步更新 selected_extra 的 DIAGRAM 状态
                const updatedSelectedExtra = hasChartTypes
                    ? modifySelectExtra({ origin, checked: true, type: 'DIAGRAM' })
                    : modifySelectExtra({ origin, checked: false, type: 'DIAGRAM' });

                this.paragraphs[level1idx].sections[level2idx].subsections[level3idx] = {
                    ...subsection,
                    selectedChartType: hasChartTypes ? chartTypes.join(',') : '',
                    chartTypeCn: chartTypeCn || null,
                    selected_extra: updatedSelectedExtra,
                };
            }
            return;
        }

        // 原有的额外功能处理逻辑
        if (level === 1) {
            // 一级章节支持（仅限文献综述和开题报告）
            if (isSupportLevel1Extra) {
                const paragraph = this.paragraphs[level1idx];
                // 确保有 extraType 和 selected_extra 字段（只包含表格和图）
                if (!paragraph.extraType) {
                    paragraph.extraType = 'NORMAL,TABLE,DIAGRAM';
                }
                const origin = paragraph.selected_extra || '';
                this.paragraphs[level1idx] = {
                    ...this.paragraphs[level1idx],
                    selected_extra: modifySelectExtra({ origin, checked, type }),
                };
            }
        } else if (level === 2) {
            const origin = this.paragraphs[level1idx].sections[level2idx].selected_extra || '';
            this.paragraphs[level1idx].sections[level2idx] = {
                ...this.paragraphs[level1idx].sections[level2idx],
                selected_extra: modifySelectExtra({ origin, checked, type }),
            };
        } else if (level === 3) {
            const origin =
                this.paragraphs[level1idx].sections[level2idx].subsections[level3idx]
                    .selected_extra || '';
            this.paragraphs[level1idx].sections[level2idx].subsections[level3idx] = {
                ...this.paragraphs[level1idx].sections[level2idx].subsections[level3idx],
                selected_extra: modifySelectExtra({ origin, checked, type }),
            };
        }
    }

    /** 获取服务列表 */
    async getServiceList() {
        try {
            const result = await get('/ai/ai/paper/add/services/list2');
            const serviceList = Array.isArray(result?.data) ? result.data : [];
            this.serviceList = serviceList
                .filter((it) => !HIDDEN_SERVICE_STYPES.includes(it?.stype))
                .map((it) => ({ ...it, checked: false }));
        } catch (error) {
            console.error(error);
        }
    }

    // 传入一个stype列表，把服务列表对应的stype设置为checked,其他的设置为false
    setServiceListByStype(stypeList) {
        this.serviceList = this.serviceList.map((it) => ({
            ...it,
            checked: stypeList.includes(it.stype),
        }));
    }

    onModalConfirmGetSummary(notiApi) {
        this.showCheckTableDialog = false;
        this.getSummary(notiApi);
    }

    get getFunType() {
        let funType = 1;
        // 开题报告传4
        if (this.docType === DocType.PROPOSAL_REPORT) {
            funType = 4;
        }
        // 文献综述传5
        if (this.docType === DocType.LITERATURE_REVIEW) {
            funType = 5;
        }
        return funType;
    }

    // 统计引用文献的标题和字数之和，不需要去除空格
    getReferenceTitleAndWordCount() {
        if (!this.customReference.customReferenceDocument.length) return 0;
        return this.customReference.customReferenceDocument.reduce((pre, cur) => {
            return pre + (cur?.title?.length || 0) + (cur?.references?.length || 0);
        }, 0);
    }

    /** 生成大纲 */
    async getSummary(notiApi) {
        if (this.customReference.customReferenceDocument.length > 50) {
            message.warning('参考文献请不要超过50篇');
            return;
        }
        // 如果引用文献的标题和字数之和大于15000，则不生成大纲
        if (this.getReferenceTitleAndWordCount() > 15000) {
            message.warning('参考文献字数请不要超过15000');
            return;
        }

        if (!this.majorName) {
            message.warning('输入全文题目后一键帮您生成大纲');
            return;
        }
        if (!this.isCheckConfirm) {
            message.warning('请先勾选免责声明');
            return;
        }
        // 如果为文献综述和开题报告，不显示确认表格
        if (
            this.docType === DocType.LITERATURE_REVIEW ||
            this.docType === DocType.PROPOSAL_REPORT
        ) {
            this.hasConfirmTable = true;
        }
        if (this.autoLightTypes.length === 0 && !this.hasConfirmTable) {
            this.showCheckTableDialog = true;
            this.hasConfirmTable = true;
            return;
        }
        // 没有引用文献
        // 没有确认无文献提示消息
        // 没有勾选推荐文献
        if (
            this.customReference.customReferenceDocument.length === 0 &&
            !this.isConfirmCustomReferenceDocument &&
            !this.isReref
        ) {
            this.confirmCustomReferenceDocumentModal = true;
            return;
        }
        const key = `getSummary`;
        this._tempAutoText = this.getAutoText();
        // 滑动到整个页面顶部
        document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
        notiApi.info({
            key,
            message: '大纲开始生成',
            description: GetSummaryNotiDom(this.getAutoText()),
            className: styles.getSummaryNoti,
            duration: 0,
            icon: <InfoCircleOutlined />,
        });
        try {
            this.paragraphs = null;
            this.isLoadingSummary = true;

            const result = await post('/ai/ai/paper/gen/outline2', {
                subject: '11',
                majorName: this.majorName,
                // threeOutline: 'y', // y or n
                enableLevel3TableOfContents: !!this.isUseThreeOutline,
                wordCount: this.wordCount,
                additionalNotes: this.additionalNotes,
                version: this.useUltra ? 'premium' : 'd',
                autoLightTypes:
                    this.autoLightTypes && this.autoLightTypes.join
                        ? this.autoLightTypes.join(',')
                        : '',
                isReref: this.isReref ? 'y' : 'n',
                funType: this.getFunType,
            });
            this.paragraphs = result.data;
            // 获取大纲后设置选中的特殊内容类型
            this.setOutlineSelectedExtra();
            this.currentStep = 1;
        } catch (e) {
            console.error(e);
        } finally {
            setTimeout(() => {
                this.isLoadingSummary = false;
                setTimeout(() => {
                    document
                        .getElementById('summaryHeader')
                        ?.scrollIntoView({ behavior: 'smooth' });
                }, 500);
            }, 700);
            notiApi.destroy(key);
        }
    }

    // 设置大纲中各章节初始选中的特殊内容类型
    setOutlineSelectedExtra = () => {
        this.paragraphs = this.paragraphs.map((it) => {
            const calcSelectedExtra = (child) => {
                const selectedExtraList = this.autoLightTypes.reduce((sum, cur) => {
                    if (child.extraTypeCn && child.extraTypeCn[cur]) {
                        sum.push(cur);
                    }
                    return sum;
                }, []);
                return selectedExtraList.join(',') || '';
            };

            it.sections &&
                it.sections.forEach((section) => {
                    section.selected_extra = calcSelectedExtra(section);
                    section.subsections &&
                        section.subsections.forEach((subsection) => {
                            subsection.selected_extra = calcSelectedExtra(subsection);
                        });
                });

            return it;
        });
    };

    setRefFileId(id) {
        this.refFileId = id;
    }

    //获取预览
    async getPreview({ inviter }) {
        try {
            this.isLoadingPreview = true;
            let customRef = {};
            // 如果是毕业论文、开题报告、文献综述，则需要使用新灵感的解法
            if (
                [
                    DocType.GRADUATION_THESIS,
                    DocType.TERM_PAPER,
                    DocType.PROPOSAL_REPORT,
                    DocType.LITERATURE_REVIEW,
                ].includes(this.docType)
            ) {
                // 获取灵感的step3的选中搜索文献数据
                const selectedSystemWenxian = this.qy.wenxianList.filter((it) =>
                    this.qy.selectIdList.includes(it.id),
                );
                customRef = [
                    ...this.customReference.customReferenceDocument,
                    ...selectedSystemWenxian,
                ].reduce(
                    (pre, cur, index) => {
                        let serialNo = index + 1;
                        if (cur?.isCustom) {
                            pre.customAbstracts.push({
                                serialNo,
                                ref: cur.references,
                                abstractText: cur.abstractContent,
                                language: 1, // 1中，2英文
                            });
                        } else {
                            pre.abstracts.push({
                                serialNo,
                                ref: cur.references,
                                abstractText: cur.abstractContent,
                                language: 1,
                            });
                        }
                        return pre;
                    },
                    {
                        abstracts: [],
                        customAbstracts: [],
                    },
                );
                // 否则用灵感的解法
            } else {
                customRef = this.customReference.customReferenceDocument.reduce(
                    (pre, cur, index) => {
                        let serialNo = index + 1;
                        if (cur?.isCustom) {
                            pre.customAbstracts.push({
                                serialNo,
                                ref: cur.references,
                                abstractText: cur.abstractContent,
                                language: 1, // 1中，2英文
                            });
                        } else {
                            pre.abstracts.push({
                                serialNo,
                                ref: cur.references,
                                abstractText: cur.abstractContent,
                                language: 1,
                            });
                        }
                        return pre;
                    },
                    {
                        abstracts: [],
                        customAbstracts: [],
                    },
                );
            }

            // const result = await post('/ai/ai/paper/gen', {
            const result = await post('/ai/ai/paper/create/paper', {
                subject: '11',
                majorName: this.majorName,
                enableLevel3TableOfContents: !!this.isUseThreeOutline,
                wordCount: this.wordCount,
                additionalNotes: this.additionalNotes,
                version: this.useUltra ? 'premium' : 'd',
                paperOutline: this.paragraphs,
                isReref: this.isReref ? 'y' : 'n',
                ...customRef,
                funType: this.getFunType,
                inviter,
                refFileId: this.refFileId,
                recommendEnglishLiterature: this.recommendEnglishLiterature,
                paperType: DOCTYPE_PAPER_TYPE_MAP.get(this.docType) ?? null,
            });

            this.paperInfo = result.data;

            await this.getServiceList();
            await this.getPriceAfterAddServices();
            console.log('preview------->', result.data);
            // this.paragraphs = result.data.outlines;
            if (
                [
                    DocType.GRADUATION_THESIS,
                    DocType.TERM_PAPER,
                    DocType.PROPOSAL_REPORT,
                    DocType.LITERATURE_REVIEW,
                ].includes(this.docType)
            ) {
                this.currentStep = 4;
            } else {
                this.currentStep = 2;
            }
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            this.isLoadingPreview = false;
        }
    }

    async getFinalPriview() {
        try {
            this.nextPreviewLoading = true;
            const customRef = this.customReference.customReferenceDocument.reduce(
                (pre, cur, index) => {
                    let serialNo = index + 1;
                    if (cur?.isCustom) {
                        pre.customAbstracts.push({
                            serialNo,
                            ref: cur.references,
                            abstractText: cur.abstractContent,
                            language: 1, // 1中，2英文
                        });
                    } else {
                        pre.abstracts.push({
                            serialNo,
                            ref: cur.references,
                            abstractText: cur.abstractContent,
                            language: 1,
                        });
                    }
                    return pre;
                },
                {
                    abstracts: [],
                    customAbstracts: [],
                },
            );
            const result = await post('/ai/ai/paper/preview/article', {
                orderNo: this.paperInfo.orderNo,
                subject: '11',
                majorName: this.majorName,
                threeOutline: this.isUseThreeOutline ? 'y' : 'n', // y or n
                version: this.useUltra ? 'premium' : 'd',
                paperOutline: this.paragraphs,
                ...customRef,
            });
            const preList = this.paperInfo.list || [];

            const list = [...preList, ...result.data.list];

            this.paperInfo.list = list;
            this.paperInfo.orderNo = result.data.orderNo;
            this.hasPreviewEnd = true;
            await Promise.all([this.getPriceAfterAddServices()]);
        } catch (error) {
            console.error(error);
        } finally {
            this.nextPreviewLoading = false;
        }
    }

    updateOutline = async () => {
        try {
            const result = await post('/ai/ai/paper/update/outlines', {
                version: this.useUltra ? 'premium' : 'd',
                paperOutline: this.paragraphs,
                orderNo: this.paperInfo.orderNo,
            });

            await Promise.all([this.getPriceAfterAddServices()]);
        } catch (error) {
            console.error(error);
        } finally {
        }
    };

    onServiceCheck(checked, serviceStype) {
        console.log('checked', checked);
        console.log('serviceStype', serviceStype);
        const serviceIndex = this.serviceList.findIndex(
            (service) => service.stype === serviceStype,
        );
        if (serviceIndex !== -1) {
            // 如果是选中操作且服务类型为aigc，实现单选逻辑
            if (checked && serviceStype.split('_')?.[1] === 'aigc') {
                // 取消所有其他aigc服务的选中状态
                this.serviceList.forEach((service) => {
                    if (
                        service.stype.split('_')?.[1] === 'aigc' &&
                        service.stype !== serviceStype
                    ) {
                        service.checked = false;
                    }
                });
            }

            // 设置当前服务选中状态
            this.serviceList[serviceIndex].checked = checked;
        }
    }

    async getPriceAfterAddServices(params = {}) {
        try {
            this.isExtraloading = true;
            const response = await post('/ai/ai/paper/add/services', {
                orderNo: this.paperInfo?.orderNo,
                ids: this.serviceList
                    .filter((s) => s.checked)
                    .map((s) => s.id)
                    .join(','),
                ...params,
            });
            if (!response.success || !response.data?.orderNo) {
                throw new Error(response.msg || '确认服务失败，请重试');
            }
            const { data } = response;

            runInAction(() => {
                this.paperInfo.orderNo = data.orderNo;

                this.paperInfo.price = data.price;
                this.paperInfo.prices = data;
                this.paperInfo.id = data.id;
                this.isExtraloading = false;
            });
            return data;
        } catch (error) {
            console.error(error);
            runInAction(() => {
                this.isExtraloading = false;
            });
            return null;
        }
    }

    async getCatogories() {
        try {
            const res = await get('/ai/paper/subject/tree');
            this.categories = res.data;
        } catch (error) {
            console.error(error);
        }
    }

    onReferenceCheck(v) {
        this.customReference.checked = v;
    }

    onReferenceChange(e) {
        this.customReference.customReferenceDocument = e.target.value;
    }

    getSelectTypeCount() {
        const data = this.paragraphs || [];
        const counts = {
            CODE: 0,
            TABLE: 0,
            DIAGRAM: 0,
            FORMULA: 0,
            DATA: 0,
        };

        // 定义有效的类型集合（排除 DIAGRAM，因为需要特殊处理）
        const validTypes = new Set(['CODE', 'TABLE', 'FORMULA', 'DATA']);

        // 优化后的计数函数（用于 CODE、TABLE、FORMULA）
        const countOccurrences = (str, type) => {
            if (!str || typeof str !== 'string') return 0;
            // 将多个空格替换为单个空格，移除首尾空格，并按逗号分割
            return str
                .split(',')
                .map((item) => item.trim())
                .filter((item) => item === type).length;
        };

        // 统计图表类型数量（用于 DIAGRAM）
        const countChartTypes = (selectedChartType) => {
            if (!selectedChartType) return 0;
            if (typeof selectedChartType === 'string') {
                return selectedChartType.split(',').filter((item) => item.trim()).length;
            }
            if (Array.isArray(selectedChartType)) {
                return selectedChartType.filter(Boolean).length;
            }
            return 0;
        };

        // 优化后的处理函数（处理 selected_extra，但不包括 DIAGRAM）
        const processSelectedExtra = (selectedExtra) => {
            if (!selectedExtra) return;

            // 预处理字符串，移除多余空格
            const cleanStr = selectedExtra.trim().replace(/\s+/g, ' ');

            // 统计每种类型的出现次数（排除 DIAGRAM）
            validTypes.forEach((type) => {
                const count = countOccurrences(cleanStr, type);
                if (count > 0) {
                    counts[type] += count;
                }
            });
        };

        // 处理图表类型（DIAGRAM）
        const processChartType = (selectedChartType) => {
            const chartCount = countChartTypes(selectedChartType);
            if (chartCount > 0) {
                counts.DIAGRAM += chartCount;
            }
        };

        // 遍历数据结构
        data.forEach((chapter) => {
            processSelectedExtra(chapter.selected_extra);
            processChartType(chapter.selectedChartType);

            if (Array.isArray(chapter.sections)) {
                chapter.sections.forEach((section) => {
                    processSelectedExtra(section.selected_extra);
                    processChartType(section.selectedChartType);

                    if (Array.isArray(section.subsections)) {
                        section.subsections.forEach((sub) => {
                            processSelectedExtra(sub.selected_extra);
                            processChartType(sub.selectedChartType);
                        });
                    }
                });
            }
        });

        return counts;
    }

    // 设置字数
    setWordCount = (count) => {
        this.wordCount = count;
    };

    // 设置模型类型
    setModelType = (type) => {
        this.modelType = type;
    };

    setAdditionalNotes = (notes) => {
        this.additionalNotes = notes;
    };
}

const summaryStore = new SummaryStore();
export { summaryStore };

function modifySelectExtra(opt) {
    const { origin, checked, type } = opt;
    // 过滤掉空字符串，避免出现 ",TABLE" 这种情况
    const originList = origin?.split(',').filter((item) => item.trim()) || [];
    const isCheckedBefore = originList.includes(type);
    if (!isCheckedBefore && checked) {
        originList.push(type);
        return originList.join(',');
    }
    if (isCheckedBefore && !checked) {
        const idx = originList.indexOf(type);
        originList.splice(idx, 1);
        return originList.join(',');
    }
    return origin;
}

const GetSummaryNotiDom = (txt) => (
    <>
        <p>
            耗时约60s，请不要刷新页面，喝杯咖啡☕️稍作等待。大纲的小节支持<b>增加</b>、<b>删除</b>、
            <b>修改</b>
        </p>
        <p className={'flex items-center'}>
            点亮小节 <span className={'-translate-y-0.5'}>{TableIcon}</span>: 插入
            <b>数据(表)</b>
        </p>
        <p className={'flex items-center'}>
            点亮小节 <span className={'-translate-y-0.5'}>{PicIcon}</span>: 插入
            <b>图</b>
        </p>
        <p className={'flex items-center'}>
            点亮小节
            <span className={'-translate-y-0.5'}>
                <CalculatorOutlined style={{ color: '#000' }} />
            </span>
            : 插入<b>公式</b>
        </p>
        <p className={'flex items-center'}>
            点亮小节
            <span className={'-translate-y-0.5'}>{DataIcon}</span>: 插入<b>数据</b>
        </p>
        <p className={'flex items-center'}>
            点亮小节
            <span className={'-translate-y-0.5'}>{CodeIcon}</span>: 插入<b>代码</b>
        </p>
        {txt && (
            <p style={{ width: '330px' }}>
                <b>灵感会自动根据您的需要点亮相应的{txt}</b>
                <br />
                您可根据需要进行<b>添加或删减</b>
            </p>
        )}
    </>
);

// 提取大纲成为目录
export function convertToTreeStructure(paperStructure) {
    // 用于生成唯一 key
    let counter = 0;

    // 创建根节点
    const treeData = {
        title: '全文目录',
        key: `node-${counter++}`,
        children: [],
    };

    // 遍历每个章节
    paperStructure.forEach((chapter) => {
        // 创建章节节点
        const chapterNode = {
            title: chapter.chapter,
            key: `node-${counter++}`,
            children: [],
            // 可选：保留其他数据作为节点的额外信息
            abstract: chapter.chapterAbstract || null,
            extraType: chapter.extraType || null,
            extraTypeCn: chapter.extraTypeCn || null,
        };

        // 如果有子节且不为 null
        if (chapter.sections && Array.isArray(chapter.sections)) {
            chapter.sections.forEach((section) => {
                // 创建子节节点
                const sectionNode = {
                    title: section.chapter,
                    key: `node-${counter++}`,
                    children: [],
                    abstract: section.chapterAbstract || null,
                    extraType: section.extraType || null,
                    extraTypeCn: section.extraTypeCn || null,
                };

                // 如果有小节且不为 null
                if (section.subsections && Array.isArray(section.subsections)) {
                    section.subsections.forEach((subsection) => {
                        sectionNode.children.push({
                            title: subsection.chapter,
                            key: `node-${counter++}`,
                            children: [],
                            abstract: subsection.chapterAbstract || null,
                            extraType: subsection.extraType || null,
                            extraTypeCn: subsection.extraTypeCn || null,
                        });
                    });
                }

                chapterNode.children.push(sectionNode);
            });
        }

        treeData.children.push(chapterNode);
    });

    return [treeData]; // Tree 组件需要数组格式
}
